/* Light Bootstrap Dashboard PRO React - v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/light-bootstrap-dashboard-pro-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { Component } from "react";
import MaskedInput from "react-text-mask";
import Select from "react-select";
//import { Prompt } from "react-router-dom";
import SweetAlert from "react-bootstrap-sweetalert";
import Resizer from "react-image-file-resizer";
import ReactDatetime from "react-datetime";

import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Label,
  FormGroup,
  Form,
  Input,
  FormText,
  Row,
  Col,
  Spinner,
} from "reactstrap";

import ImageUpload from "components/CustomUpload/ImageUpload.jsx";
import {
  validateEmail,
  validateSin,
  getCurrentDate,
} from "components/Utilities/utilities.js";
import { auth, firebase, fs, store } from "components/Firebase/firebase.js";
import SignatureCanvas from "react-signature-canvas";
import "components/CustomStyles/sigCanvas.css";
import logo from "assets/img/hydralogofull.png"

class CreateNewUser extends Component {
  constructor(props) {
    super(props);
    this.defaultState = {
      signature: null,
      rawSignature: null,
      progress: 0,
      firstName: null,
      lastName: null,
      availability: [
        {
          // 0: Monday
          active: false,
          m: true,
          a: true,
          n: true,
        },
        {
          active: false,
          m: true,
          a: true,
          n: true,
        },
        {
          active: false,
          m: true,
          a: true,
          n: true,
        },
        {
          active: false,
          m: true,
          a: true,
          n: true,
        },
        {
          active: false,
          m: true,
          a: true,
          n: true,
        },
        {
          active: false,
          m: true,
          a: true,
          n: true,
        },
        {
          // 6: Sunday
          active: false,
          m: true,
          a: true,
          n: true,
        },
      ],
      gender: null,
      pinNumber: null,
      badgeNumber: null,
      dob: null, // must be 18 +
      phone: null,
      address: null,
      pinNumber: null,
      badgeNumber: null,
      city: null,
      province: null,
      postalCode: null,
      sin: null,
      sinToSend: null,
      legallyWork: null,
      selected: false,
      completedTraining: {
        general: {
          completedDate: null,
          completed: false,
          expireDate: null,
        },
      },
      workStatus: null,
      emergencyFirstName: null, //the first emergency contact is mandatory
      emergencyLastName: null,
      emergencyPhone: null,
      emergencyRelationship: null,
      email: null,
      confirmEmail: null,
      licenseNumber: null,

      // States for images, 1 is government license, 3 is security license
      // 5 is work permit (appears if workstatus is set to work permit)
      // 7 is student work visa (appears if workstatus is set to student visa)
      image1: null,
      image3: null,
      image5: null,
      image7: null,
      signature: null,

      //Errors
      errorFirstName: "",
      errorLastName: "",
      errorAvailability: "",
      errorGender: "",
      errorAge: "",
      errorPhone: "",
      errorLicenseNumber: "",

      errorAddress: "",
      errorCity: "",
      errorProvince: "",
      errorPostalCode: "",
      errorSin: "",
      errorCompletedTraining: "",
      errorLegallyWork: "",
      errorWorkStatus: "",
      errorImage1: "",
      errorImage3: "",
      errorImage5: "",
      errorImage7: "",
      errorEmergencyFirstName: "",
      errorEmergencyLastName: "",
      errorEmergencyPhone: "",
      errorEmergencyRelationship: "",
      errorEmail: "",
      errorConfirmEmail: "",
      errorSignature: "",

      // Loading
      isLoading: false,
      showWorkPermit: false,
      showStudentVisa: false,
    };
    this.state = this.defaultState;
  }

  componentDidMount() {
    // Database References
    this.applicantDataRef = fs.collection("applicant_data");
    this.applicantCountersRef = fs.collection("counters").doc("applicants");
    this.applicantStorageRef = store.ref("applicant_files/");
    //window.addEventListener("beforeunload", this.handleUserLeave);
  }
  componentWillUnmount() {
    //window.removeEventListener("beforeunload", this.handleUserLeave);
  }

  handleUserLeave = (e) => {
    const confirmationMessage = "Data would be sent if you leave the page";
    (e || window.event).returnValue = confirmationMessage;
    return confirmationMessage;
  };

  scrollToFirstError = () => {
    //Convert to camelcase by adding prototype to String
    String.prototype.toLowerCaseFirstLetter = function () {
      return this.charAt(0).toLowerCase() + this.slice(1);
    };
    try {
      for (let prop in this.state) {
        if (prop.match(/^error+/) && this.state[prop]) {
          //console.log(prop, this.state[prop]);
          const id = prop.replace(/^error+/, "").toLowerCaseFirstLetter();
          var element = document.getElementById(id);
          element.scrollIntoView({
            behavior: "smooth",
            block: "center",
            inline: "nearest",
          });
          //By default scrollintoview takes some time to scroll smoothly so I set a settimeout function to
          //delay the focus so that it can normally scroll
          setTimeout(() => {
            element.focus();
          }, 500);
          break;
        }
      }
    } catch (e) {
      console.log("error", e);
    }
  };

  resizeFile = (file) =>
    new Promise((resolve) => {
      Resizer.imageFileResizer(
        file,
        1200,
        1200,
        "JPEG",
        50,
        0,
        (uri) => {
          resolve(uri);
        },
        "blob"
      );
    });

  handleSubmit = () => {
    let tempState = this.state; // Copy of state
    let hasError = false;
    // Start of Error Handling
    if (tempState.firstName == null || tempState.firstName == "") {
      this.setState({ errorFirstName: "* Must have a first name." });
      hasError = true;
    } else {
      this.setState({ errorFirstName: "" });
    }

    if (tempState.lastName == null || tempState.lastName == "") {
      this.setState({ errorLastName: "* Must have a last name." });
      hasError = true;
    } else {
      this.setState({ errorLastName: "" });
    }

    if (
      tempState.availability[0].active == false &&
      tempState.availability[1].active == false &&
      tempState.availability[2].active == false &&
      tempState.availability[3].active == false &&
      tempState.availability[4].active == false &&
      tempState.availability[5].active == false &&
      tempState.availability[6].active == false
    ) {
      hasError = true;
      this.setState({
        errorAvailability: "* Must have at least 1 day available for work.",
      });
    } else {
      this.setState({ errorAvailability: "" });
    }

    if (tempState.gender == null || tempState.gender == "") {
      this.setState({ errorGender: "* Must select a gender." });
      hasError = true;
    } else {
      this.setState({ errorGender: "" });
    }

    if (tempState.licenseNumber == null || tempState.licenseNumber == "") {
      this.setState({ errorLicenseNumber: "* Must have a license number." });
      hasError = true;
    } else {
      this.setState({ errorLicenseNumber: "" });
    }

    if (!tempState.dob) {
      this.setState({ errorAge: "* Must have date of birth." });
      hasError = true;
    } else if (new Date().getYear() - new Date(tempState.dob._d).getYear() < 18) {
      this.setState({ errorAge: "* Must be 18 or older." });
      hasError = true;
    } else {
      this.setState({ errorAge: "" });
    }

    if (tempState.phone == null || tempState.phone == "") {
      this.setState({ errorPhone: "* Must have a phone number." }); // No phone number
      hasError = true;
    } else {
      if (tempState.phone.length != 10 || tempState.phone < 0) {
        this.setState({ errorPhone: "* Please input a valid phone number." }); //invalid phone number
        hasError = true;
      } else {
        this.setState({ errorPhone: "" });
      }
    }

    if (tempState.email == null || tempState.email == "") {
      this.setState({ errorEmail: "* Must have an email" }); // No email text
    } else {
      if (tempState.email != null && validateEmail(tempState.email) === false) {
        this.setState({ errorEmail: "* Please input a valid email" }); //invalid email text
        hasError = true;
      } else {
        this.setState({ errorEmail: "" });
      }
    }

    if (tempState.address == null || tempState.address == "") {
      this.setState({ errorAddress: "* Must have a street address." });
      hasError = true;
    } else {
      this.setState({ errorAddress: "" });
    }

    if (tempState.city == null || tempState.city == "") {
      this.setState({ errorCity: "* Must have a city." });
      hasError = true;
    } else {
      this.setState({ errorCity: "" });
    }

    if (tempState.province == null || tempState.province == "") {
      this.setState({ errorProvince: "* Must have a province." });
      hasError = true;
    } else {
      this.setState({ errorProvince: "" });
    }

    if (tempState.postalCode == null || tempState.postalCode == "") {
      this.setState({ errorPostalCode: "* Must have a postal code." });
      hasError = true;
    } else {
      let regExp = "^[A-Za-z][0-9][A-Za-z][0-9][A-Za-z][0-9]$"; //logic for postal code format A1B2C3, case insensitive
      if (
        tempState.postalCode.match(regExp) == null ||
        tempState.postalCode.length != 6
      ) {
        this.setState({
          errorPostalCode:
            "* Please input a valid postal code in the format A1A1A1.",
        }); //invalid postal code
        hasError = true;
      } else {
        this.setState({ errorPostalCode: "" });
      }
    }

    if (tempState.sin == null || tempState.sin == "") {
      this.setState({ errorSin: "* Must have a SIN." }); //No sin
      hasError = true;
    } else {
      if (validateSin(tempState.sin) === false || tempState.sin.length != 9) {
        this.setState({ errorSin: "* Please input a valid SIN." }); //invalid sin
        hasError = true;
      } else if (validateSin(tempState.sin) === true) {
        this.setState({ errorSin: "" });
      }
    }

    if (tempState.completedTraining == null) {
      this.setState({ errorCompletedTraining: "* Must select yes or no" });
      hasError = true;
    } else {
      this.setState({ errorCompletedTraining: "" });
    }

    if (tempState.legallyWork == null) {
      this.setState({ errorLegallyWork: "* Must select yes or no" });
      hasError = true;
    } else {
      this.setState({ errorLegallyWork: "" });
    }

    if (tempState.workStatus == null) {
      this.setState({ errorWorkStatus: "* Must select a work status" });
      hasError = true;
    } else {
      this.setState({ errorWorkStatus: "" });
    }

    if (tempState.emergencyFirstName == null) {
      this.setState({
        errorEmergencyFirstName:
          "* Must have a first name for the emergency contact.",
      });
      hasError = true;
    } else {
      this.setState({ errorEmergencyFirstName: "" });
    }

    if (tempState.emergencyLastName == null) {
      this.setState({
        errorEmergencyLastName:
          "* Must have a last name for the emergency contact.",
      });
      hasError = true;
    } else {
      this.setState({ errorEmergencyLastName: "" });
    }

    if (tempState.emergencyPhone == null || tempState.emergencyPhone == "") {
      this.setState({
        errorEmergencyPhone:
          "* Must have a phone number for the emergency contact.",
      }); // No phone number
      hasError = true;
    } else {
      if (
        tempState.emergencyPhone.length != 10 ||
        tempState.emergencyPhone < 0
      ) {
        this.setState({
          errorEmergencyPhone:
            "* Please input a valid phone number for the emergency contact.",
        }); //invalid phone number
        hasError = true;
      } else {
        this.setState({ errorEmergencyPhone: "" });
      }
    }

    if (tempState.emergencyRelationship == null) {
      this.setState({
        errorEmergencyRelationship:
          "* Must have a relationship for the emergency contact.",
      });
      hasError = true;
    } else {
      this.setState({ errorEmergencyRelationship: "" });
    }

    if (tempState.image1 == null) {
      this.setState({
        errorImage1:
          "* Must upload an image (png, jpg or jpeg) for the front of the government license",
      });
      hasError = true;
    } else {
      this.setState({ errorImage1: "" });
    }

    if (tempState.image3 == null) {
      this.setState({
        errorImage3: "* Must upload an image (png, jpg or jpeg) for the front of the security license",
      });
      hasError = true;
    } else {
      this.setState({ errorImage3: "" });
    }

    if (tempState.image5 == null && tempState.showWorkPermit == true) {
      this.setState({
        errorImage5: "* Must upload an image (png, jpg or jpeg) for the front of the work permit",
      });
      hasError = true;
    } else {
      this.setState({ errorImage5: "" });
    }

    if (tempState.image7 == null && tempState.showStudentVisa == true) {
      this.setState({
        errorImage7: "* Must upload an image (png, jpg or jpeg) for the front of the student visa",
      });
      hasError = true;
    } else {
      this.setState({ errorImage7: "" });
    }

    if (tempState.signature == null) {
      this.setState({ errorSignature: "* Must have a signature." });
      hasError = true;
    } else {
      this.setState({ errorSignature: "" });
    }

    if (tempState.confirmEmail == null || tempState.confirmEmail == "") {
      this.setState({ errorConfirmEmail: "* Must confirm email." });
      hasError = true;
    } else if (tempState.confirmEmail !== tempState.email) {
      this.setState({ errorConfirmEmail: "* Your emails do not match" });
      hasError = true;
    } else {
      this.setState({ errorConfirmEmail: "" });
    }

    if (hasError) {
      this.setState({
        alert: (
          <SweetAlert
            warning
            title="Please ensure all mandatory fields (*) are filled"
            onConfirm={this.hideAlert}
          />
        ),
      });
      return;
    } else {
      this.prepareAndSendDataToServer(this.toLowerCase(tempState));
    }
  };

  //Convert every obj element to lowercase if it has string
  toLowerCase(obj) {
    let newObj = {};
    for (let prop in obj) {
      //console.log(prop, obj[prop]);
      if (typeof obj[prop] === "string") {
        newObj[prop] = obj[prop].toLowerCase();
      } else {
        newObj[prop] = obj[prop];
      }
    }
    return newObj;
  }

  prepareAndSendDataToServer = async (tempState) => {
    this.setState({ isLoading: true });

          let currentDate = new Date();
          let sin = tempState.sin;
          this.applicantDataRef
            .where("sin", "==", `${sin}`)
            .get()
            .then(async (snapshot) => {
              // Memory leak on fail.
              if (snapshot.empty) {
                console.log("no existing user for this sin, proceeding with account creation")
                this.applicantCountersRef
                  .get() // 1. Get current counter value
                  .then(async (doc) => { // 2. Prepare object to be sent with obtained counter value
                    let dataToSend = null; // Data prepared to send.
                    let updateDateTime = getCurrentDate(); // gets the current date, and turns it into a nice string format "yyyy-mm-dd: hh:mm:ss"
                    let HSId = doc.data().total;
                    {
                      let promises = [];
                      if (tempState.image1 === null || tempState.image3 === null || tempState.signature === null) {
                        this.setState({
                          isLoading: false,
                          alert: (
                            <SweetAlert
                              danger
                              title={`Your images were not correctly uploaded.`}
                              onConfirm={this.hideAlert}
                            >
                              Your data upload has been cancelled. Please try again.
                            </SweetAlert>
                          )
                        });
                      } else {
                        if (tempState.image1 != null) {
                          let image1Upload = this.applicantStorageRef
                            .child(`${HSId}/1.jpeg`)
                            .put(tempState.image1);
                          promises.push(image1Upload);
                        }
                        if (tempState.image3 != null) {
                          let image3Upload = this.applicantStorageRef
                            .child(`${HSId}/3.jpeg`)
                            .put(tempState.image3);
                          promises.push(image3Upload);
                        }
                        if (tempState.image5 != null) {
                          let image5Upload = this.applicantStorageRef
                            .child(`${HSId}/5.jpeg`)
                            .put(tempState.image5);
                          promises.push(image5Upload);
                        }
                        if (tempState.image7 != null) {
                          let image7Upload = this.applicantStorageRef
                            .child(`${HSId}/7.jpeg`)
                            .put(tempState.image7);
                          promises.push(image7Upload);
                        }
                        if (tempState.signature != null) {
                          let signatureUpload = this.applicantStorageRef
                            .child(`${HSId}/signature`)
                            .put(tempState.signature);
                          promises.push(signatureUpload);
                        }

                        promises.forEach((promise) => {
                          {
                            promise.on(
                              "state_changed",
                              (snapshot) => {
                                // Observe state change events such as progress, pause, and resume
                                // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
                                var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                                console.log("Upload is " + progress + "% done");
                                switch (snapshot.state) {
                                  case firebase.storage.TaskState.PAUSED: // or 'paused'
                                    console.log("Upload is paused");
                                    break;
                                  case firebase.storage.TaskState.RUNNING: // or 'running'
                                    console.log("Upload is running");
                                    break;
                                }
                              },
                              (error) => {
                                // Handle unsuccessful uploads
                                console.log("Firebase file upload error: ", error);
                                this.setState({
                                  isLoading: false,
                                  alert: (
                                    <SweetAlert
                                      danger
                                      title={`Your images were not correctly uploaded.`}
                                      onConfirm={this.hideAlert}
                                    >
                                      Your data upload has been cancelled. Please try again.
                                    </SweetAlert>
                                  )
                                });
                              },
                              () => {
                                // Handle successful uploads on complete
                                promise.snapshot.ref.getDownloadURL().then(function (downloadURL) {
                                  console.log("File available at", downloadURL);
                                  return downloadURL;
                                });
                              }
                            );
                          };
                        });
                        try {
                          await Promise.all(promises)
                            .then(() => {  // This is the general search data. Additional History fields are stored in a deeper collection. See 4.
                              dataToSend = { // General Information
                                HSId: HSId,
                                firstName: tempState.firstName,
                                lastName: tempState.lastName,
                                availability: tempState.availability,
                                gender: tempState.gender,
                                dob: new Date(tempState.dob),
                                phone: tempState.phone,
                                email: tempState.email,
                                licenseNumber: tempState.licenseNumber,
                                address: tempState.address,
                                city: tempState.city,
                                province: tempState.province.value,
                                postalCode: tempState.postalCode,
                                sin: tempState.sin,
                                legallyWork: tempState.legallyWork,
                                selected: false,
                                workStatus: tempState.workStatus,
                                emergencyFirstName: tempState.emergencyFirstName,
                                emergencyLastName: tempState.emergencyLastName,
                                emergencyPhone: tempState.emergencyPhone,
                                emergencyRelationship: tempState.emergencyRelationship,
                                createdDate: currentDate, // Current time
                                updatedDate: currentDate, // Uppdated Time
                              };
                            }
                            )
                            .then(() => {
                              console.log("Step 4 start: ");
                              return ( // Send data to server with firebase generating document key using built in scatter algorithm
                                this.applicantDataRef.add(dataToSend)
                              );
                            })
                            .then((docRef) => {
                              // 5. Create empty History and status object at this newly created document
                              console.log("Step 5: Doc Id: ", docRef);
                              this.applicantDataRef
                                .doc(docRef.id)
                                .collection("history")
                                .doc("main")
                                .set({
                                  changeLog: [
                                    {
                                      admin: "User Action",
                                      time: updateDateTime,
                                      action: "Created User",
                                    },
                                  ],
                                });
                            })
                            .then(() => { // Update firestore counter by 1
                              console.log("Step 5 start");
                              this.applicantCountersRef.update({
                                total: firebase.firestore.FieldValue.increment(1),
                              });
                            })
                            .then(() => {
                              this.setState({
                                isLoading: false,
                                alert: (
                                  <SweetAlert
                                    success
                                    title={`Upload successful!`}
                                    onConfirm={this.hideAlert}
                                  >
                                    Your registration is complete!
                                  </SweetAlert>
                                ),
                                ...this.defaultState
                              });
                              return false
                            })
                        } catch (error) {
                          this.setState({
                            isLoading: false,
                            alert: (
                              <SweetAlert
                                danger
                                title={`An error has occured: ${error.code}`}
                                onConfirm={this.hideAlert}
                              >
                                {error.code}
                              </SweetAlert>
                            )
                          });
                        }
                      }
                    }
                  })
              } else {
                //sin number already exists, no new account is created
                this.setState({
                  isLoading: false,
                  alert: (
                    <SweetAlert
                      danger
                      title={`This sin number is already in the database`}
                      onConfirm={this.hideAlert}
                    >
                      A user already exists for this sin.
                    </SweetAlert>
                  )
                });
                return false
              }
            });
       
  }

  hideAlert = () => {
    this.setState({
      alert: null,
    });
    this.scrollToFirstError();
  };

  addImageToState = async (stateName, image) => {
    const resizedImage = await this.resizeFile(image);
    this.setState({ [stateName]: resizedImage });
  };

  removeImageFromState = (stateName) => {
    this.setState({ [stateName]: null });
  };

  handleRadio = (event) => {
    const target = event.target;
    this.setState({
      [target.name]: target.value,
    });
  };

  // day = number between 0 (monday) to 6 (sunday)
  toggleCheckMark = (day) => {
    let tempAvailability = this.state.availability;
    tempAvailability[day].active = !tempAvailability[day].active;
    this.setState({ availability: tempAvailability });
  };

  // MAN = choice of "m", "a", "n" for morning afternoon or night
  toggleShifts = (MAN, day) => {
    let tempAvailability = this.state.availability;

    MAN == "m"
      ? (tempAvailability[day].m = !tempAvailability[day].m) // m
      : MAN == "a"
        ? (tempAvailability[day].a = !tempAvailability[day].a) // a
        : (tempAvailability[day].n = !tempAvailability[day].n); // n

    this.setState({ availability: tempAvailability });
  };

  _renderWorkPermit = () => {
    if (this.state.showWorkPermit == true) {
      return (
        <Row>
          <Label sm="2">* Work Permit</Label>
          <Col sm="5">
            <CardTitle tag="p">* (Front)</CardTitle>
            <ImageUpload
              addImageToState={this.addImageToState}
              imageState="image5"
              removeImageFromState={this.removeImageFromState}
            />
            <FormText color="danger" tag="span">
              {this.state.errorImage5}
            </FormText>
          </Col>
          <Col sm="4">
          </Col>
        </Row>
      );
    }
  };

  _renderStudentVisa = () => {
    if (this.state.showStudentVisa == true) {
      return (
        <Row>
          <Label sm="2">* Student Visa</Label>
          <Col sm="5">
            <CardTitle tag="p">* (Front)</CardTitle>
            <ImageUpload
              addImageToState={this.addImageToState}
              imageState="image7"
              removeImageFromState={this.removeImageFromState}
            />
            <FormText color="danger" tag="span">
              {this.state.errorImage7}
            </FormText>
          </Col>
          <Col sm="4">
          </Col>
        </Row>
      );
    }
  };

  _renderAvailability = (dayOfWeekText, day) => {
    return (
      <Row>
        <Col sm="2">
          <FormGroup check inline>
            <Label check>
              <Input
                type="checkbox"
                onChange={() => this.toggleCheckMark(day)}
                checked={this.state.availability[day].active === true}
                id={dayOfWeekText === "Monday" ? "availability" : null}
              />
              <span className="form-check-sign" />
              {dayOfWeekText}
            </Label>
          </FormGroup>
        </Col>

        {this.state.availability[day].active ? (
          <Col sm="10">
            <FormGroup check inline>
              <Label check>
                <Input
                  type="checkbox"
                  checked={this.state.availability[day].m}
                  onChange={() => this.toggleShifts("m", day)}
                />
                <span className="form-check-sign" />
                Morning
              </Label>
            </FormGroup>

            <FormGroup check inline>
              <Label check>
                <Input
                  type="checkbox"
                  checked={this.state.availability[day].a}
                  onChange={() => this.toggleShifts("a", day)}
                />
                <span className="form-check-sign" />
                Afternoon
              </Label>
            </FormGroup>

            <FormGroup check inline>
              <Label check>
                <Input
                  type="checkbox"
                  checked={this.state.availability[day].n}
                  onChange={() => this.toggleShifts("n", day)}
                />
                <span className="form-check-sign" />
                Night
              </Label>
            </FormGroup>
          </Col>
        ) : null}
      </Row>
    );
  };

  disableFutureDates = current => {
    const today = new Date();
    return current.isBefore(today)
  }

  loadingOverlay = () => {
    return (
      <SweetAlert
        style={{
          display: "block",
          marginTop: "-100px",
          background: "transparent",
        }}
        title={
          <Spinner color="light" style={{ width: "3rem", height: "3rem" }} />
        }
        onConfirm={this.hideAlert}
        showConfirm={false}
      />
    );
  };

  signaturePad = {};
  clearSignature = () => {
    this.signaturePad.clear();
    this.setState({ signature: null });
  };

  saveSignature = () => {
    let signature = this.signaturePad.getTrimmedCanvas().toDataURL("image/png");
    let b64Data = signature.replace("data:image/png;base64,", "")
    const byteCharacters = atob(b64Data);
    const byteArrays = [];
    let contentType = 'image/png';
    let sliceSize = 512;
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    const blob = new Blob(byteArrays, { type: contentType });
    console.log("image, ", blob)
    this.setState({
      signature: blob,
    });
  };

  render() {
    return (
      <div>
        {this.state.isLoading ? (
          this.loadingOverlay()
        ) : (
            <Row style={{ margin: 0, padding: 0 }}>
              <Col lg="3"></Col>
              <Col lg="6">
                <Card>
                  <CardHeader
                    style={{ alignItems: "center", textAlign: "center" }}
                  >
                    <img
                      src={logo}
                      alt="Hydra Security Logo"
                      height="200"
                    ></img>
                    <br></br>
                    <div
                      style={{
                        borderColor: "#D8CBC7",
                        borderStyle: "solid",
                        borderWidth: "0.3px",
                        width: "100%",
                        height: 0,
                        marginTop: "35px",
                        marginBottom: "15px",
                      }}
                    />
                    <CardTitle tag="h4" style={{ fontWeight: "bold" }}>
                      Job Application
                  </CardTitle>
                    <p>
                      Please read carefully and fill out all information to the
                      best of your knowledge. If this application leads to
                      employment, you understand that false or misleading
                      information in your application or interview may result in
                      your release.
                    </p>
                    <div
                      style={{
                        borderColor: "#D8CBC7",
                        borderStyle: "solid",
                        borderWidth: "0.3px",
                        width: "100%",
                        height: 0,
                        marginTop: "35px",
                        marginBottom: "25px",
                      }}
                    />
                    {/*<Row>
                    <Col sm="2"></Col>
                    <Col sm="8" align="center">
                      <p>Already registered but haven't completed training?</p>
                      <Button
                        color="secondary"
                        onClick={() =>
                          this.props.history.push("/continue-training")
                        }
                      >
                        Continue Training
                      </Button>
                    </Col>
                    <Col sm="2"></Col>
                  </Row>
                  <div
                    style={{
                      borderColor: "#D8CBC7",
                      borderStyle: "solid",
                      borderWidth: "0.3px",
                      width: "100%",
                      height: 0,
                      marginTop: "35px",
                      marginBottom: "25px",
                    }}
                  />*/}
                  </CardHeader>
                  <CardBody>
                    <Form action="/" className="form-horizontal" method="get">
                      <Row>
                        <Label sm="2">* First Name</Label>
                        <Col sm="5">
                          <FormGroup>
                            <Input
                              type="text"
                              autoComplete="off"
                              onChange={(e) =>
                                this.setState({ firstName: e.target.value })
                              }
                              value={this.state.firstName || ""}
                              id="firstName"
                            />
                            <FormText color="danger" tag="span">
                              {this.state.errorFirstName}
                            </FormText>
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Label sm="2">* Last Name</Label>
                        <Col sm="5">
                          <FormGroup>
                            <Input
                              type="text"
                              autoComplete="off"
                              onChange={(e) =>
                                this.setState({ lastName: e.target.value })
                              }
                              value={this.state.lastName || ""}
                              id="lastName"
                            />
                            <FormText color="danger" tag="span">
                              {this.state.errorLastName}
                            </FormText>
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Label sm="2">* Security License</Label>
                        <Col sm="5">
                          <FormGroup>
                            <Input
                              type="text"
                              autoComplete="off"
                              onChange={(e) =>
                                this.setState({ licenseNumber: e.target.value })
                              }
                              value={this.state.licenseNumber || ""}
                              id="licenseNumber"
                            />
                            <FormText color="danger" tag="span">
                              {this.state.errorLicenseNumber}
                            </FormText>
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Label sm="2">* Availability</Label>
                        <Col className="checkbox-radios" sm="10">
                          {this._renderAvailability("Monday", 0)}
                          {this._renderAvailability("Tuesday", 1)}
                          {this._renderAvailability("Wednesday", 2)}
                          {this._renderAvailability("Thursday", 3)}
                          {this._renderAvailability("Friday", 4)}
                          {this._renderAvailability("Saturday", 5)}
                          {this._renderAvailability("Sunday", 6)}
                          <FormText color="danger" tag="span">
                            {this.state.errorAvailability}
                          </FormText>
                        </Col>
                      </Row>
                      <Row>
                        <Label sm="2">* Gender</Label>
                        <Col className="checkbox-radios" sm="10">
                          <div
                            className="form-check-radio"
                            style={{ marginTop: 8 }}
                          >
                            <Label check id="gender">
                              <Input
                                defaultValue="M"
                                id="M"
                                name="genderRadio"
                                type="radio"
                                onChange={() => this.setState({ gender: "M" })}
                                checked={this.state.gender === "M"}
                              />
                            Male <span className="form-check-sign" />
                            </Label>
                          </div>
                          <div className="form-check-radio">
                            <Label check>
                              <Input
                                defaultValue="F"
                                id="F"
                                name="genderRadio"
                                type="radio"
                                onChange={() => this.setState({ gender: "F" })}
                                checked={this.state.gender === "F"}
                              />
                            Female <span className="form-check-sign" />
                            </Label>
                            <FormText color="danger" tag="span">
                              {this.state.errorGender}
                            </FormText>
                          </div>
                        </Col>
                      </Row>

                      <Row>
                        <Label sm="2">* Date of Birth</Label>
                        <Col sm="5">
                          <FormGroup>
                            <ReactDatetime
                              input={false}
                              timeFormat={false}
                              isValidDate={this.disableFutureDates}
                              value={this.state.dob}
                              onChange={(value) => {
                                this.setState({
                                  dob: value
                                })
                              }}
                              id="dob"
                            />
                            <FormText color="danger" tag="span">
                              {this.state.errorAge}
                            </FormText>
                          </FormGroup>
                        </Col>
                      </Row>

                      <Row>
                        <Label sm="2">* Phone Number</Label>
                        <Col sm="5">
                          <FormGroup>
                            <MaskedInput
                              mask={[
                                "(",
                                /[1-9]/,
                                /\d/,
                                /\d/,
                                ")",
                                "-",
                                /\d/,
                                /\d/,
                                /\d/,
                                "-",
                                /\d/,
                                /\d/,
                                /\d/,
                                /\d/,
                              ]}
                              className="form-control"
                              autoComplete="off"
                              maxLength="15"
                              placeholder="(xxx)-xxx-xxxx"
                              onChange={(e) => {
                                //Allows the user to type in any format. Only numbers will be added to the state
                                let input = e.target.value;
                                let replacedPhone = input.replace(/[^0-9]/g, "");
                                this.setState({ phone: replacedPhone });
                              }}
                              value={this.state.phone || ""}
                              id="phone"
                            />
                            <FormText color="danger" tag="span">
                              {this.state.errorPhone}
                            </FormText>
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Label sm="2">* Street Address</Label>
                        <Col sm="5">
                          <FormGroup>
                            <Input
                              type="text"
                              autoComplete="off"
                              onChange={(e) =>
                                this.setState({ address: e.target.value })
                              }
                              value={this.state.address || ""}
                              id="address"
                            />
                            <FormText color="danger" tag="span">
                              {this.state.errorAddress}
                            </FormText>
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Label sm="2">* City</Label>
                        <Col sm="5">
                          <FormGroup>
                            <Input
                              type="text"
                              autoComplete="off"
                              onChange={(e) =>
                                this.setState({ city: e.target.value })
                              }
                              value={this.state.city || ""}
                              id="city"
                            />
                            <FormText color="danger" tag="span">
                              {this.state.errorCity}
                            </FormText>
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Label sm="2">* Province</Label>
                        <Col sm="5">
                          <FormGroup>
                            <Select
                              className="react-select primary"
                              classNamePrefix="react-select"
                              name="singleSelect"
                              value={this.state.province}
                              onChange={(value) =>
                                this.setState({ province: value })
                              }
                              id="province"
                              options={[
                                { value: "Alberta", label: "Alberta" },
                                {
                                  value: "British Columbia",
                                  label: "British Columbia",
                                },
                                { value: "Manitoba", label: "Manitoba" },
                                {
                                  value: "New Brunswick",
                                  label: "New Brunswick",
                                },
                                {
                                  value: "Newfoundland and Labrador",
                                  label: "Newfoundland and Labrador",
                                },
                                {
                                  value: "Northwest Territories",
                                  label: "Northwest Territories",
                                },
                                { value: "Nova Scotia", label: "Nova Scotia" },
                                { value: "Nunavut", label: "Nunavut" },
                                { value: "Ontario", label: "Ontario" },
                                {
                                  value: "Prince Edward Island",
                                  label: "Prince Edward Island",
                                },
                                { value: "Quebec", label: "Quebec" },
                                { value: "Saskatchewan", label: "Saskatchewan" },
                                { value: "Yukon", label: "Yukon" },
                              ]}
                              placeholder="Select a province"
                            />
                            <FormText color="danger" tag="span">
                              {this.state.errorProvince}
                            </FormText>
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Label sm="2">* Postal Code</Label>
                        <Col sm="5">
                          <FormGroup>
                            <MaskedInput
                              mask={[
                                /[A-Za-z]/,
                                /\d/,
                                /[A-Za-z]/,
                                " ",
                                /\d/,
                                /[A-Za-z]/,
                                /\d/,
                              ]}
                              id="postalCode"
                              className="form-control"
                              autoComplete="off"
                              maxLength="8"
                              placeholder="A1B 2C3"
                              onChange={(e) => {
                                let input = e.target.value;
                                let replacedPostalCode = input.replace(
                                  /[^a-zA-Z_0-9-]/g,
                                  ""
                                );
                                this.setState({ postalCode: replacedPostalCode });
                              }}
                              value={this.state.postalCode || ""}
                            />
                            <FormText color="danger" tag="span">
                              {this.state.errorPostalCode}
                            </FormText>
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Label sm="2">* Social Insurance Number</Label>
                        <Col sm="5">
                          <FormGroup>
                            <MaskedInput
                              mask={[
                                /\d/,
                                /\d/,
                                /\d/,
                                " ",
                                /\d/,
                                /\d/,
                                /\d/,
                                " ",
                                /\d/,
                                /\d/,
                                /\d/,
                              ]}
                              id="sin"
                              className="form-control"
                              autoComplete="off"
                              maxLength="12"
                              placeholder="xxx xxx xxx"
                              onChange={(e) => {
                                //Allows the user to type in any format. Only numbers will be added to the state
                                let input = e.target.value;
                                let replacedSin = input.replace(/[^0-9]/g, "");
                                this.setState({ sin: replacedSin });
                              }}
                              value={this.state.sin || ""}
                            />
                            <FormText color="danger" tag="span">
                              {this.state.errorSin}
                            </FormText>
                          </FormGroup>
                        </Col>
                      </Row>

                      <Row>
                        <Label sm="2">* Legally Allowed to Work?</Label>
                        <Col className="checkbox-radios" sm="10">
                          <div
                            className="form-check-radio"
                            style={{ marginTop: 8 }}
                          >
                            <Label check id="completedTraining">
                              <Input
                                defaultValue
                                id="Yes"
                                name="40hRadio"
                                type="radio"
                                onChange={() =>
                                  this.setState({ legallyWork: true })
                                }
                                checked={this.state.legallyWork}
                              />
                            Yes <span className="form-check-sign" />
                            </Label>
                          </div>
                          <div className="form-check-radio" id="legallyWork">
                            <Label check>
                              <Input
                                defaultValue
                                id="No"
                                name="40hRadio"
                                type="radio"
                                onChange={() =>
                                  this.setState({ legallyWork: false })
                                }
                                checked={this.state.legallyWork === false}
                              />
                            No <span className="form-check-sign" />
                            </Label>
                            <FormText color="danger" tag="span">
                              {this.state.errorLegallyWork}
                            </FormText>
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Label sm="2">* Work Status</Label>
                        <Col sm="5">
                          <FormGroup>
                            <Select
                              id="workStatus"
                              className="react-select primary"
                              classNamePrefix="react-select"
                              name="singleSelect"
                              value={this.state.workStatus}
                              onChange={(value) => {
                                this.setState({ workStatus: value });
                                if (value.value == "showWorkPermit") {
                                  this.setState({
                                    showWorkPermit: true,
                                    showStudentVisa: false,
                                    image7: null,
                                    image8: null,
                                  });
                                } else if (value.value == "showStudentVisa") {
                                  this.setState({
                                    showStudentVisa: true,
                                    showWorkPermit: false,
                                    image5: null,
                                    image6: null,
                                  });
                                } else {
                                  this.setState({
                                    showWorkPermit: false,
                                    showStudentVisa: false,
                                    image5: null,
                                    image6: null,
                                    image7: null,
                                    image8: null,
                                  });
                                }
                              }}
                              options={[
                                {
                                  value: "showCitizen",
                                  label: "Permanent Residence/Citizen",
                                },
                                { value: "showWorkPermit", label: "Work Permit" },
                                {
                                  value: "showStudentVisa",
                                  label: "Student Visa",
                                },
                              ]}
                              placeholder="Select a work status"
                            />
                            <FormText color="danger" tag="span">
                              {this.state.errorWorkStatus}
                            </FormText>
                          </FormGroup>
                        </Col>
                      </Row>

                      <Row>
                        <Label sm="2">
                          * Government Issued Photo ID (passport or driver's
                          license)
                      </Label>
                        <Col sm="5">
                          <CardTitle tag="p">* (Front)</CardTitle>
                          <ImageUpload
                            addImageToState={this.addImageToState}
                            imageState="image1"
                            removeImageFromState={this.removeImageFromState}
                            id="image1"
                          />
                          <FormText color="danger" tag="span">
                            {this.state.errorImage1}
                          </FormText>
                        </Col>
                        <Col sm="4">
                        </Col>
                      </Row>

                      <Row>
                        <Label sm="2">* Security License</Label>
                        <Col sm="5">
                          <CardTitle tag="p">* (Front)</CardTitle>
                          <ImageUpload
                            addImageToState={this.addImageToState}
                            imageState="image3"
                            id="image3"
                            removeImageFromState={this.removeImageFromState}
                          />
                          <FormText color="danger" tag="span">
                            {this.state.errorImage3}
                          </FormText>
                        </Col>
                        <Col sm="">
                        </Col>
                      </Row>
                      {this._renderWorkPermit()}
                      {this._renderStudentVisa()}
                      <div
                        style={{
                          width: "100%",
                          height: 0,
                          marginTop: "35px",
                          marginBottom: "25px",
                        }}
                      />
                      <Row>
                        <Label sm="2">* Emergency Contact</Label>
                        <Col sm="4">
                          <FormGroup>
                            <Input
                              type="text"
                              autoComplete="off"
                              placeholder="* First Name"
                              onChange={(e) =>
                                this.setState({
                                  emergencyFirstName: e.target.value,
                                })
                              }
                              value={this.state.emergencyFirstName || ""}
                              id="emergencyFirstName"
                            />
                            <FormText color="danger" tag="span">
                              {this.state.errorEmergencyFirstName}
                            </FormText>
                          </FormGroup>
                        </Col>
                        <Col sm="4">
                          <FormGroup>
                            <MaskedInput
                              mask={[
                                "(",
                                /[1-9]/,
                                /\d/,
                                /\d/,
                                ")",
                                "-",
                                /\d/,
                                /\d/,
                                /\d/,
                                "-",
                                /\d/,
                                /\d/,
                                /\d/,
                                /\d/,
                              ]}
                              className="form-control"
                              autoComplete="off"
                              maxLength="15"
                              placeholder="(xxx)-xxx-xxxx"
                              onChange={(e) => {
                                //Allows the user to type in any format. Only numbers will be added to the state
                                let input = e.target.value;
                                let replacedPhone = input.replace(/[^0-9]/g, "");
                                this.setState({ emergencyPhone: replacedPhone });
                              }}
                              value={this.state.emergencyPhone || ""}
                              id="emergencyPhone"
                            />
                            <FormText color="danger" tag="span">
                              {this.state.errorEmergencyPhone}
                            </FormText>
                          </FormGroup>
                        </Col>
                        <Label sm="2"></Label>
                      </Row>
                      <Row>
                        <Label sm="2"></Label>
                        <Col sm="4">
                          <FormGroup>
                            <Input
                              type="text"
                              autoComplete="off"
                              placeholder="* Last Name"
                              onChange={(e) =>
                                this.setState({
                                  emergencyLastName: e.target.value,
                                })
                              }
                              value={this.state.emergencyLastName || ""}
                              id="emergencyLastName"
                            />
                            <FormText color="danger" tag="span">
                              {this.state.errorEmergencyLastName}
                            </FormText>
                          </FormGroup>
                        </Col>
                        <Col sm="4">
                          <FormGroup>
                            <Input
                              type="text"
                              autoComplete="off"
                              placeholder="* Relationship"
                              onChange={(e) =>
                                this.setState({
                                  emergencyRelationship: e.target.value,
                                })
                              }
                              value={this.state.emergencyRelationship || ""}
                              id="emergencyRelationship"
                            />
                            <FormText color="danger" tag="span">
                              {this.state.errorEmergencyRelationship}
                            </FormText>
                          </FormGroup>
                        </Col>
                        <Label sm="2"></Label>
                      </Row>
                      <div
                        style={{
                          width: "100%",
                          height: 0,
                          marginTop: "35px",
                          marginBottom: "25px",
                        }}
                      />
                      <div
                        style={{
                          borderColor: "#D8CBC7",
                          borderStyle: "solid",
                          borderWidth: "0.3px",
                          width: "100%",
                          height: 0,
                          marginTop: "35px",
                          marginBottom: "25px",
                        }}
                      />
                      <Row>
                        <Label sm="2">* Email</Label>
                        <Col sm="5">
                          <FormGroup>
                            <Input
                              type="email"
                              autoComplete="off"
                              placeholder="Enter your email"
                              onChange={(e) =>
                                this.setState({ email: e.target.value })
                              }
                              value={this.state.email || ""}
                              id="email"
                            />
                            <FormText color="danger" tag="span">
                              {this.state.errorEmail}
                            </FormText>
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Label sm="2">* Confirm Email</Label>
                        <Col sm="5">
                          <FormGroup>
                            <Input
                              type="email"
                              autoComplete="off"
                              placeholder="Confirm your email"
                              onChange={(e) =>
                                this.setState({ confirmEmail: e.target.value })
                              }
                              value={this.state.confirmEmail || ""}
                              id="confirmEmail"
                            />
                            <FormText color="danger" tag="span">
                              {this.state.errorConfirmEmail}
                            </FormText>
                          </FormGroup>
                        </Col>
                      </Row>
                      <div
                        style={{
                          borderColor: "#D8CBC7",
                          borderStyle: "solid",
                          borderWidth: "0.3px",
                          width: "100%",
                          height: 0,
                          marginTop: "35px",
                          marginBottom: "25px",
                        }}
                      />
                      <div
                        style={{
                          width: "100%",
                          height: 0,
                          marginTop: "35px",
                          marginBottom: "35px",
                        }}
                      />
                      <Row>
                        <Label sm="2">Input signature here</Label>
                        <Col sm="8">
                          <SignatureCanvas
                            penColor="orange"
                            ref={(ref) => {
                              this.signaturePad = ref;
                            }}
                            canvasProps={{
                              className: "signatureCanvas",
                            }}
                            onEnd={() => {
                              this.saveSignature();
                            }}
                            id="signature"
                          />
                          <FormText color="danger" tag="span">
                            {this.state.errorSignature}
                          </FormText>
                        </Col>
                        <Col sm="2"></Col>
                      </Row>
                      <Row>
                        <Col sm="2"></Col>
                        <Col sm="10">
                          <Button
                            width="100%"
                            color="secondary"
                            onClick={this.clearSignature}
                          >
                            Clear
                        </Button>
                        </Col>
                      </Row>
                      <Row>
                        <Col sm="10" align="right">
                          <Button
                            color="warning"
                            size="lg"
                            onClick={() => this.handleSubmit()}
                          >
                            Submit
                        </Button>
                        </Col>
                        <Col sm="2"></Col>
                      </Row>
                      <div
                        style={{
                          width: "100%",
                          height: 0,
                          marginTop: "35px",
                          marginBottom: "25px",
                        }}
                      />
                    </Form>
                  </CardBody>
                </Card>
              </Col>
              <Col lg="3"></Col>
            </Row>
          )}
        {this.state.alert}
      </div>
    );
  }
}

export default CreateNewUser;
